import React from 'react'

const ErrorTextblock = () => (
  <div className="text-block">
    <h1>Aw, snap!</h1>
    <p>We seem to have lost that page somewhere…</p>
  </div>
)

export default ErrorTextblock
